import { Action } from "redux";

import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

import { ShoppingFilter, ShoppingSorting } from "./Shopping.contants";

export interface MessagesCount {
    [productId: number]: {
        total: number;
        new: number;
    };
}

export interface ShoppingLoadApiAction extends Action {
    readonly username: string;
    readonly filter: ShoppingFilter;
    readonly sort: ShoppingSorting;
    readonly page: number;
}

export const SHOPPING_LOAD_API_REQUEST = "SHOPPING_LOAD_API_REQUEST";

export interface ShoppingLoadApiRequestAction extends ShoppingLoadApiAction, APIRequestAction {
    readonly type: typeof SHOPPING_LOAD_API_REQUEST;
}

export interface ShoppingLoadApiNormalizedResponse extends NormalizedResponse {
    readonly result: {
        readonly products: number[];
    };
}

export const SHOPPING_LOAD_API_SUCCESS = "SHOPPING_LOAD_API_SUCCESS";

export interface ShoppingLoadApiSuccessAction
    extends ShoppingLoadApiAction, APISuccessAction<ShoppingLoadApiNormalizedResponse> {
    readonly type: typeof SHOPPING_LOAD_API_SUCCESS;
    readonly hits: number;
    readonly messagesCount: MessagesCount;
}

export const SHOPPING_LOAD_API_FAILURE = "SHOPPING_LOAD_API_FAILURE";

export interface ShoppingLoadApiFailureAction extends ShoppingLoadApiAction, APIFailureAction {
    readonly type: typeof SHOPPING_LOAD_API_FAILURE;
}

export const shoppingLoadApi = {
    request: (
        username: string,
        filter: ShoppingFilter,
        sort: ShoppingSorting,
        page: number,
    ): ShoppingLoadApiRequestAction => ({
        type: SHOPPING_LOAD_API_REQUEST,
        username,
        filter,
        sort,
        page,
    }),
    success: (
        username: string,
        filter: ShoppingFilter,
        sort: ShoppingSorting,
        page: number,
        hits: number,
        messagesCount: MessagesCount,
        response: ShoppingLoadApiNormalizedResponse,
    ): ShoppingLoadApiSuccessAction => ({
        type: SHOPPING_LOAD_API_SUCCESS,
        username,
        filter,
        sort,
        page,
        hits,
        messagesCount,
        response,
    }),
    failure: (
        username: string,
        filter: ShoppingFilter,
        sort: ShoppingSorting,
        page: number,
        error: any,
    ): ShoppingLoadApiFailureAction => ({
        type: SHOPPING_LOAD_API_FAILURE,
        username,
        filter,
        sort,
        page,
        error,
    }),
};

export const SHOPPING_LOAD = "SHOPPING_LOAD";

export interface ShoppingLoadAction extends ShoppingLoadApiAction {
    readonly type: typeof SHOPPING_LOAD;
}

export const shoppingLoad = (
    username: string,
    filter: ShoppingFilter,
    sort: ShoppingSorting,
    page: number,
): ShoppingLoadAction => ({
    type: SHOPPING_LOAD,
    username,
    filter,
    sort,
    page,
});

export interface ShoppingArchiveApiAction extends Action {
    readonly username: string;
    readonly ids: number[];
    readonly filter: ShoppingFilter;
    readonly sort: ShoppingSorting;
    readonly page: number;
}

export const SHOPPING_ARCHIVE_API_REQUEST = "SHOPPING_ARCHIVE_API_REQUEST";

export interface ShoppingArchiveApiRequestAction
    extends ShoppingArchiveApiAction, APIRequestAction {
    readonly type: typeof SHOPPING_ARCHIVE_API_REQUEST;
}

export interface ShoppingArchiveApiNormalizedResponse extends NormalizedResponse {
    readonly result: {};
}

export const SHOPPING_ARCHIVE_API_SUCCESS = "SHOPPING_ARCHIVE_API_SUCCESS";

export interface ShoppingArchiveApiSuccessAction
    extends ShoppingArchiveApiAction, APISuccessAction<ShoppingArchiveApiNormalizedResponse> {
    readonly type: typeof SHOPPING_ARCHIVE_API_SUCCESS;
}

export const SHOPPING_ARCHIVE_API_FAILURE = "SHOPPING_ARCHIVE_API_FAILURE";

export interface ShoppingArchiveApiFailureAction
    extends ShoppingArchiveApiAction, APIFailureAction {
    readonly type: typeof SHOPPING_ARCHIVE_API_FAILURE;
}

export const shoppingArchiveApi = {
    request: (
        username: string,
        filter: ShoppingFilter,
        sort: ShoppingSorting,
        page: number,
        ids: number[],
    ): ShoppingArchiveApiRequestAction => ({
        type: SHOPPING_ARCHIVE_API_REQUEST,
        username,
        ids,
        filter,
        sort,
        page,
    }),
    success: (
        username: string,
        filter: ShoppingFilter,
        sort: ShoppingSorting,
        page: number,
        ids: number[],
        response: ShoppingArchiveApiNormalizedResponse,
    ): ShoppingArchiveApiSuccessAction => ({
        type: SHOPPING_ARCHIVE_API_SUCCESS,
        username,
        ids,
        filter,
        sort,
        page,
        response,
    }),
    failure: (
        username: string,
        filter: ShoppingFilter,
        sort: ShoppingSorting,
        page: number,
        ids: number[],
        error: any,
    ): ShoppingArchiveApiFailureAction => ({
        type: SHOPPING_ARCHIVE_API_FAILURE,
        username,
        ids,
        filter,
        sort,
        page,
        error,
    }),
};

export const SHOPPING_ARCHIVE = "SHOPPING_ARCHIVE";

export interface ShoppingArchiveAction extends ShoppingArchiveApiAction {
    readonly type: typeof SHOPPING_ARCHIVE;
}

export const shoppingArchive = (
    username: string,
    filter: ShoppingFilter,
    sort: ShoppingSorting,
    page: number,
    ids: number[],
): ShoppingArchiveAction => ({
    type: SHOPPING_ARCHIVE,
    username,
    ids,
    filter,
    sort,
    page,
});
